export default [
  {
    path: '/dash/emailtofind',
    name: 'EmailToFind',
    component: () => import('@/modules/emailToFind/pages/EmailToFind.vue'),
    meta: {
      authRequired: true,
      pageTitle: 'Email to Find',
      breadcrumb: [
        {
          text: 'Find email progress step wise.',
          active: true,
        },
      ],
    },
  },
];
